import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-button-selection-group',
  templateUrl: './button-selection-group.component.html',
  styleUrls: ['./button-selection-group.component.scss'],
  standalone: false
})
export class ButtonSelectionGroup {

  @Input() options!: string[];
  @Input() multiSelection: boolean = false;
  @Input() selectedOptions: string[] = [];
  @Input() submitted: boolean = false;
  
  @Output() selectedOptionsChange: EventEmitter<any> = new EventEmitter();

  constructor() {}

  handleSelect(option: string) {
    if (this.multiSelection) {
      if (this.selectedOptions.includes(option)) {
        this.selectedOptions.splice(this.selectedOptions.indexOf(option), 1);
      } else {
        this.selectedOptions.push(option);
      }
      this.selectedOptionsChange.emit(this.selectedOptions);
    } else {
      this.selectedOptions = [option];
      this.selectedOptionsChange.emit(this.selectedOptions);
    }
  }
}
